export default {
  state: {
    docs: [
      {
        title: 'Государственный музей "Смольный"',
        subtitle: 'Благодарственное письмо',
        image: require('@/assets/img/MA_1920_ru_awards1.jpg'),
        isFull: false,
        isEn: false,
        article: '',
        linkPdf: '/static/Государственный музей_Смольный.pdf'
      },
      {
        title: 'Музей бронетанковой техники',
        subtitle: 'Благодарность',
        image: require('@/assets/img/MA_1920_ru_awards2.jpg'),
        isFull: false,
        isEn: false,
        article: '',
        linkPdf: '/static/Музей бронетанковой техники_Благодарность.pdf'
      },
      {
        title: 'Министерство  Культуры Российской Федерации. Музей-заповедник "Прохоровское поле."',
        subtitle: 'Рекомендательное письмо',
        image: require('@/assets/img/MA_1920_ru_awards3.jpg'),
        isFull: false,
        isEn: false,
        article: '',
        linkPdf: '/static/Прохоровское поле.pdf'
      },
      {
        title: 'Статья. "Как создают современные музеи."',
        subtitle: 'Публикация, Февраль 2017',
        image: require('@/assets/img/MA_1920_ru_awards4.jpg'),
        isFull: true,
        isEn: false,
        article: '<h1>ОНОНАС. "Как создают современные' +
            ' музеи."</h1><p>Lorem ipsum dolor sit amet, consectetur' +
            ' adipisicing elit. Blanditiis consectetur necessitatibus' +
            ' quidem quos sint tempora vitae, voluptatum. Aliquid animi' +
            ' corporis ipsam labore nisi non quisquam reprehenderit.' +
            ' Accusantium at atque dignissimos ducimus enim et explicabo' +
            ' facere in molestias qui quidem sunt suscipit tenetur,' +
            ' ullam, unde! Animi doloremque doloribus eligendi est ipsam?</p>' +
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
            ' Autem corporis cum cupiditate delectus deleniti doloremque' +
            ' excepturi id, mollitia natus obcaecati porro possimus ratione,' +
            ' temporibus. Alias aperiam cum dignissimos distinctio dolorum' +
            ' harum illo in inventore ipsum iusto labore maxime modi molestiae' +
            ' omnis pariatur, placeat quidem quo, tempore tenetur velit.' +
            ' Atque et fuga hic incidunt ipsa! A aliquam culpa, cupiditate' +
            ' debitis dicta dignissimos, dolorem enim error facilis hic illo' +
            ' iste labore magni mollitia officiis quibusdam repellendus saepe' +
            ' sed sequi sint soluta, veritatis vitae! Ad debitis delectus' +
            ' dignissimos error in incidunt officia quaerat.</p>' +
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
            ' Autem corporis cum cupiditate delectus deleniti doloremque' +
            ' excepturi id, mollitia natus obcaecati porro possimus ratione,' +
            ' temporibus. Alias aperiam cum dignissimos distinctio dolorum' +
            ' harum illo in inventore ipsum iusto labore maxime modi molestiae' +
            ' omnis pariatur, placeat quidem quo, tempore tenetur velit.' +
            ' Atque et fuga hic incidunt ipsa! A aliquam culpa, cupiditate' +
            ' debitis dicta dignissimos, dolorem enim error facilis hic illo' +
            ' iste labore magni mollitia officiis quibusdam repellendus saepe' +
            ' sed sequi sint soluta, veritatis vitae! Ad debitis delectus' +
            ' dignissimos error in incidunt officia quaerat.</p>' +
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
            ' Autem corporis cum cupiditate delectus deleniti doloremque' +
            ' excepturi id, mollitia natus obcaecati porro possimus ratione,' +
            ' temporibus. Alias aperiam cum dignissimos distinctio dolorum' +
            ' harum illo in inventore ipsum iusto labore maxime modi molestiae' +
            ' omnis pariatur, placeat quidem quo, tempore tenetur velit.' +
            ' Atque et fuga hic incidunt ipsa! A aliquam culpa, cupiditate' +
            ' debitis dicta dignissimos, dolorem enim error facilis hic illo' +
            ' iste labore magni mollitia officiis quibusdam repellendus saepe' +
            ' sed sequi sint soluta, veritatis vitae! Ad debitis delectus' +
            ' dignissimos error in incidunt officia quaerat.</p>' +
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
            ' Autem corporis cum cupiditate delectus deleniti doloremque' +
            ' excepturi id, mollitia natus obcaecati porro possimus ratione,' +
            ' temporibus. Alias aperiam cum dignissimos distinctio dolorum' +
            ' harum illo in inventore ipsum iusto labore maxime modi molestiae' +
            ' omnis pariatur, placeat quidem quo, tempore tenetur velit.' +
            ' Atque et fuga hic incidunt ipsa! A aliquam culpa, cupiditate' +
            ' debitis dicta dignissimos, dolorem enim error facilis hic illo' +
            ' iste labore magni mollitia officiis quibusdam repellendus saepe' +
            ' sed sequi sint soluta, veritatis vitae! Ad debitis delectus' +
            ' dignissimos error in incidunt officia quaerat.</p>' +
            '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.' +
            ' Autem corporis cum cupiditate delectus deleniti doloremque' +
            ' excepturi id, mollitia natus obcaecati porro possimus ratione,' +
            ' temporibus. Alias aperiam cum dignissimos distinctio dolorum' +
            ' harum illo in inventore ipsum iusto labore maxime modi molestiae' +
            ' omnis pariatur, placeat quidem quo, tempore tenetur velit.' +
            ' Atque et fuga hic incidunt ipsa! A aliquam culpa, cupiditate' +
            ' debitis dicta dignissimos, dolorem enim error facilis hic illo' +
            ' iste labore magni mollitia officiis quibusdam repellendus saepe' +
            ' sed sequi sint soluta, veritatis vitae! Ad debitis delectus' +
            ' dignissimos error in incidunt officia quaerat.</p>',
        linkPdf: '/static/ОНОНАС.pdf'
      },
    ]
  },
  getters: {
    docs(state) {
      return state.docs
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/docs.js